import { BLOG_IMAGES } from '@/lib/site'

export const niches = [
  { slug: 'humor', name: 'Humor', blurb: 'Páginas de memes e entretenimento com alcance diário.' },
  { slug: 'moda', name: 'Moda', blurb: 'Looks, tendências e vitrines digitais para marcas e afiliados.' },
  { slug: 'financas', name: 'Finanças', blurb: 'Educação financeira, investimentos e conteúdo de renda.' },
  { slug: 'fitness', name: 'Fitness', blurb: 'Treino, emagrecimento e rotina saudável com audiência fiel.' },
  { slug: 'gastronomia', name: 'Gastronomia', blurb: 'Receitas, restaurantes e autoridade no universo da comida.' },
  { slug: 'viagens', name: 'Viagens', blurb: 'Destinos, roteiros e inspiração para quem vive fora de casa.' },
  { slug: 'pets', name: 'Pets', blurb: 'Cães, gatos e produtos pet com alto potencial de conversão.' },
  { slug: 'games', name: 'Games', blurb: 'Gameplay, react e cultura gamer com público jovem.' },
  { slug: 'beleza', name: 'Beleza', blurb: 'Maquiagem, skincare e estética com engajamento alto.' },
  { slug: 'motivacional', name: 'Motivacional', blurb: 'Frases, hábitos e desenvolvimento pessoal no feed.' },
  { slug: 'marketing', name: 'Marketing', blurb: 'Estratégia, tráfego pago e cases para quem vende serviço digital.' },
  { slug: 'entretenimento', name: 'Entretenimento', blurb: 'Curiosidades, cultura pop e conteúdo viral para todos os públicos.' },
  { slug: 'futebol', name: 'Futebol', blurb: 'Bastidores, resenha e paixão pelo esporte mais popular do Brasil.' },
  { slug: 'cortes', name: 'Cortes', blurb: 'Cortes de podcast, lives e entrevistas prontos para viralizar.' },
  { slug: 'outros', name: 'Outros', blurb: 'Nichos variados fora das categorias tradicionais, sob consulta.' },
] as const

export type NicheSlug = (typeof niches)[number]['slug']

export const followerBands = [
  { slug: '1k-10k', label: '1k–10k', title: 'Perfis de entrada', text: 'Ideal para testar um nicho, começar a vender ou migrar um projeto pessoal com custo menor.' },
  { slug: '10k-50k', label: '10k–50k', title: 'Autoridade em formação', text: 'Já sustentam parcerias locais, conteúdo diário e primeira tração comercial.' },
  { slug: '50k-100k', label: '50k–100k', title: 'Páginas intermediárias', text: 'Bom equilíbrio entre preço, alcance e histórico orgânico da conta.' },
  { slug: '100k-300k', label: '100k–300k', title: 'Alto alcance', text: 'Indicadas para infoproduto, afiliação e marcas que precisam de volume.' },
  { slug: '300k-900k', label: '300k–900k', title: 'Grandes páginas', text: 'Ativos raros, com anos de postagem e audiência consolidada no nicho.' },
] as const

export type BandSlug = (typeof followerBands)[number]['slug']

export type Profile = {
  id: string
  handle: string
  niche: NicheSlug
  followers: string
  followersNum: number
  band: BandSlug
  engagement: string
  age: string
  posts: string
  summary: string
}

export const profiles: Profile[] = [
  {
    id: 'mm-01',
    handle: '@risadasdobrasil',
    niche: 'humor',
    followers: '48,2 mil',
    followersNum: 48200,
    band: '10k-50k',
    engagement: '4,1%',
    age: '4 anos',
    posts: '1.280',
    summary: 'Memes nacionais com postagem consistente e comentários orgânicos.',
  },
  {
    id: 'mm-02',
    handle: '@vitrineurbana',
    niche: 'moda',
    followers: '112 mil',
    followersNum: 112000,
    band: '100k-300k',
    engagement: '2,4%',
    age: '6 anos',
    posts: '2.040',
    summary: 'Looks e vitrines com público majoritariamente feminino, 18 a 34 anos.',
  },
  {
    id: 'mm-03',
    handle: '@bolsoemdia',
    niche: 'financas',
    followers: '67,5 mil',
    followersNum: 67500,
    band: '50k-100k',
    engagement: '3,2%',
    age: '3 anos',
    posts: '890',
    summary: 'Educação financeira simples, carrosséis e Reels de alto retenção.',
  },
  {
    id: 'mm-04',
    handle: '@treinocompacto',
    niche: 'fitness',
    followers: '29,8 mil',
    followersNum: 29800,
    band: '10k-50k',
    engagement: '5,0%',
    age: '2 anos',
    posts: '640',
    summary: 'Treinos em casa e emagrecimento, forte em stories e Direct.',
  },
  {
    id: 'mm-05',
    handle: '@pratacheia.bh',
    niche: 'gastronomia',
    followers: '8,4 mil',
    followersNum: 8400,
    band: '1k-10k',
    engagement: '6,3%',
    age: '2 anos',
    posts: '410',
    summary: 'Receitas rápidas e restaurantes, ótima porta de entrada no nicho.',
  },
  {
    id: 'mm-06',
    handle: '@rotasleves',
    niche: 'viagens',
    followers: '156 mil',
    followersNum: 156000,
    band: '100k-300k',
    engagement: '2,1%',
    age: '7 anos',
    posts: '1.760',
    summary: 'Destinos nacionais e dicas de roteiro, histórico limpo e orgânico.',
  },
  {
    id: 'mm-07',
    handle: '@patasnafila',
    niche: 'pets',
    followers: '21,1 mil',
    followersNum: 21100,
    band: '10k-50k',
    engagement: '4,7%',
    age: '3 anos',
    posts: '720',
    summary: 'Cães e gatos com alto compartilhamento e perfil de compra pet.',
  },
  {
    id: 'mm-08',
    handle: '@respawndiario',
    niche: 'games',
    followers: '109 mil',
    followersNum: 109000,
    band: '100k-300k',
    engagement: '3,6%',
    age: '5 anos',
    posts: '3.100',
    summary: 'Gameplay, react e cultura gamer — página no estilo das que mais saem.',
  },
  {
    id: 'mm-09',
    handle: '@peleemcamadas',
    niche: 'beleza',
    followers: '220 mil',
    followersNum: 220000,
    band: '100k-300k',
    engagement: '2,8%',
    age: '6 anos',
    posts: '1.950',
    summary: 'Maquiagem e skincare com histórico de parcerias e Reels virais.',
  },
  {
    id: 'mm-10',
    handle: '@habitoleve',
    niche: 'motivacional',
    followers: '32,4 mil',
    followersNum: 32400,
    band: '10k-50k',
    engagement: '3,9%',
    age: '4 anos',
    posts: '980',
    summary: 'Hábitos, frases e rotina — perfil clássico para infoproduto.',
  },
  {
    id: 'mm-11',
    handle: '@forcademanha',
    niche: 'fitness',
    followers: '410 mil',
    followersNum: 410000,
    band: '300k-900k',
    engagement: '1,8%',
    age: '8 anos',
    posts: '4.220',
    summary: 'Página grande de treino, audiência consolidada e username curto.',
  },
  {
    id: 'mm-12',
    handle: '@cafedigital.br',
    niche: 'financas',
    followers: '6,1 mil',
    followersNum: 6100,
    band: '1k-10k',
    engagement: '5,8%',
    age: '18 meses',
    posts: '260',
    summary: 'Finanças para iniciantes, conta jovem com crescimento orgânico.',
  },
  {
    id: 'mm-13',
    handle: '@growthdiario',
    niche: 'marketing',
    followers: '18,7 mil',
    followersNum: 18700,
    band: '10k-50k',
    engagement: '3,4%',
    age: '3 anos',
    posts: '560',
    summary: 'Dicas de tráfego pago e cases de marketing digital, público de empreendedores.',
  },
  {
    id: 'mm-14',
    handle: '@telalarga.oficial',
    niche: 'entretenimento',
    followers: '134 mil',
    followersNum: 134000,
    band: '100k-300k',
    engagement: '2,6%',
    age: '5 anos',
    posts: '2.310',
    summary: 'Curiosidades, cultura pop e virais — alcance alto e comentário orgânico.',
  },
  {
    id: 'mm-15',
    handle: '@resenhadobola',
    niche: 'futebol',
    followers: '76 mil',
    followersNum: 76000,
    band: '50k-100k',
    engagement: '4,4%',
    age: '4 anos',
    posts: '1.480',
    summary: 'Resenha e bastidores do futebol brasileiro, comunidade engajada em jogos.',
  },
  {
    id: 'mm-16',
    handle: '@cortesdapodcast',
    niche: 'cortes',
    followers: '41,3 mil',
    followersNum: 41300,
    band: '10k-50k',
    engagement: '3,8%',
    age: '2 anos',
    posts: '910',
    summary: 'Cortes de podcast e entrevistas com potencial viral em Reels.',
  },
  {
    id: 'mm-17',
    handle: '@variedadesbr',
    niche: 'outros',
    followers: '9,9 mil',
    followersNum: 9900,
    band: '1k-10k',
    engagement: '5,1%',
    age: '18 meses',
    posts: '380',
    summary: 'Conteúdo variado fora das categorias tradicionais, boa base para nichar depois.',
  },
]

export const testimonials = [
  {
    name: 'Diogo M.',
    city: 'São Paulo, SP',
    niche: 'Beleza · 220k',
    quote:
      'Comprei um perfil de 220 mil seguidores no nicho de maquiagem. A transferência foi acompanhada passo a passo e o histórico da conta bateu com o que foi apresentado.',
  },
  {
    name: 'Washington A.',
    city: 'Belo Horizonte, MG',
    niche: 'Motivacional · 32k',
    quote:
      'Negociação objetiva. Recebi opções no nicho de motivação, escolhi um perfil de 32 mil e em poucos dias já estava postando no meu nome.',
  },
  {
    name: 'Iroeni P.',
    city: 'Curitiba, PR',
    niche: 'Pets · 6k',
    quote:
      'Comecei com uma página menor de pets, 6 mil seguidores reais. Serviu para validar o conteúdo antes de pensar em um perfil maior.',
  },
  {
    name: 'Luiza Silva',
    city: 'Rio de Janeiro, RJ',
    niche: 'Negócios · 10k',
    quote:
      'Meu negócio cresceu depois que comprei uma conta de 10 mil seguidores. O suporte humano fez diferença na hora de trocar e-mail e autenticação.',
  },
  {
    name: 'Rafael C.',
    city: 'Campinas, SP',
    niche: 'Games · 109k',
    quote:
      'Procurei especificamente uma página gamer. A curadoria evitou perfil com seguidores inflados. Engajamento veio junto com o número.',
  },
  {
    name: 'Camila N.',
    city: 'Fortaleza, CE',
    niche: 'Moda · 112k',
    quote:
      'Queria comprar página no Instagram para afiliados de moda. A Muita Mídia mostrou métricas antes do pagamento e o contrato deixou o processo claro.',
  },
]

export type FaqItem = {
  q: string
  a: string[]
  tags?: string[]
}

export const faqs: FaqItem[] = [
  {
    q: 'Posso personalizar o perfil depois de comprar?',
    a: [
      'Sim, você tem controle total! Você pode mudar completamente o perfil e personalizá-lo do seu jeito: @username, nome completo, bio, foto de perfil e tudo mais.',
      'O perfil passa a ser 100% seu após a transferência. Você pode adaptar conforme a identidade visual e estratégia do seu projeto.',
    ],
    tags: ['✏️ Edição total', '🎨 Personalização livre'],
  },
  {
    q: 'Como eu recebo o acesso do perfil?',
    a: [
      'Você recebe tudo pelo WhatsApp! A entrega é feita imediatamente após o pagamento ser confirmado.',
      'Você receberá: login e senha de acesso, email vinculado à conta e orientações completas para a transferência segura.',
      'Acompanhamos todo o passo a passo para garantir que a transferência ocorra com total segurança e você tenha controle completo do perfil.',
    ],
    tags: ['⚡ Entrega imediata', '🔐 Acesso completo'],
  },
  {
    q: 'Quais formas de pagamento vocês aceitam?',
    a: [
      'Operamos com pagamentos via Pix e cartão de crédito.',
      'Pix (recomendado): garante descontos especiais e pagamento à vista com confirmação instantânea.',
      'Cartão de crédito: parcele em até 12x, com juros do link de pagamento sendo pagos pelo cliente.',
    ],
    tags: ['💰 Pix com desconto', '💳 12x no cartão', '⚡ Aprovação rápida'],
  },
  {
    q: 'Os perfis possuem violações?',
    a: [
      'Não! Todos os perfis são avaliados manualmente por nós antes de chegar até você.',
      'Não compramos qualquer página — somente páginas que estão em dia com as políticas da plataforma (diretrizes da Meta/Instagram) e sem histórico de violações ou restrições.',
      'Nossa verificação inclui: compliance com políticas, ausência de shadowban, histórico de conteúdo e integridade da conta.',
    ],
    tags: ['✅ Verificação manual', '🛡️ Sem violações', '✓ Conforme políticas Meta'],
  },
  {
    q: 'Os seguidores são reais?',
    a: [
      'Sim, 100% reais! Vendemos apenas páginas com seguidores reais e orgânicos — páginas que cresceram organicamente no Instagram.',
      'Nada de bots, automações, compra de seguidores, seguidores falsos ou engajamento inflado artificialmente.',
      'Você recebe uma base autêntica, construída de forma natural, com pessoas reais que seguem o nicho da página. Pronta para você continuar publicando e desenvolvendo seu projeto.',
    ],
    tags: ['👥 Seguidores reais', '🌱 Crescimento orgânico', '🚫 Zero automação'],
  },
  {
    q: 'Qual a garantia que tenho?',
    a: [
      'Todas as páginas possuem garantia de 7 dias, conforme previsto na lei brasileira (Código de Defesa do Consumidor).',
      'Você pode solicitar o reembolso integral do valor da página dentro desse prazo, desde que a página esteja nas mesmas condições em que foi entregue a você.',
      'Atenção importante: após alterações no perfil (mudança de @, nome, foto, bio, etc.), a compra não pode ser desfeita. A garantia de 7 dias é válida apenas se o perfil permanecer nas condições originais de entrega.',
    ],
    tags: ['✅ Garantia de 7 dias', '⚠️ Válida sem alterações'],
  },
  {
    q: 'Quanto tempo leva o processo de transferência?',
    a: [
      'O processo é super rápido! Após a confirmação do pagamento, você recebe o acesso imediatamente pelo WhatsApp.',
      'Orientamos o passo a passo completo para a transferência segura: mudança de email, senha, autenticação em dois fatores e verificação de propriedade.',
      'Geralmente, em poucos minutos você já está com o perfil totalmente sob seu controle, pronto para começar a publicar.',
    ],
    tags: ['⚡ Acesso imediato', '📋 Passo a passo completo'],
  },
  {
    q: 'Vocês dão suporte após a compra?',
    a: [
      'Com certeza! Oferecemos suporte completo após a compra pelo WhatsApp.',
      'Nosso suporte inclui orientação completa sobre transferência e configuração do perfil, dúvidas técnicas sobre acesso, senha e email vinculado, além de sugestões estratégicas para começar a publicar com consistência.',
      'Estamos aqui para que você comece a trabalhar com segurança e confiança.',
    ],
    tags: ['💬 Suporte via WhatsApp', '🤝 Acompanhamento completo'],
  },
  {
    q: 'A Muita Mídia é dona de todas as páginas?',
    a: [
      'Sim! Todas as páginas já estão conectadas em nossos computadores, garantindo acesso seguro e imediato para você.',
      'Isso importa porque a transferência é 100% segura e acompanhada por nós, com orientação completa em toda a transição (mudança de email, senha, 2FA), e você recebe acesso validado e testado antes da compra.',
      'Não revendemos páginas de terceiros sem controle. Cada perfil em nosso catálogo está sob nossa propriedade e gestão direta até a transferência completa para você.',
    ],
    tags: ['🏢 Propriedade verificada', '🔐 Acesso seguro', '✓ Gestão direta'],
  },
]

export const steps = [
  {
    n: '01',
    title: 'Escolha o nicho',
    text: 'Você diz o segmento, a faixa de seguidores e o objetivo: autoridade, afiliação, infoproduto ou marca pessoal.',
  },
  {
    n: '02',
    title: 'Receba as opções',
    text: 'Enviamos perfis compatíveis, com seguidores, engajamento, idade da conta e observações de risco.',
  },
  {
    n: '03',
    title: 'Pagamento seguro',
    text: 'Fechamento com contrato, CNPJ à vista e pagamento via Pix ou transferência, sem intermediário informal.',
  },
  {
    n: '04',
    title: 'Transferência assistida',
    text: 'Trocamos e-mail, senha, celular e autenticação com você na linha, até o perfil estar no seu controle.',
  },
]

export type Article = {
  slug: string
  title: string
  description: string
  date: string
  read: string
  image: string
  imageAlt: string
  kicker: string
  content: { heading?: string; paragraphs: string[] }[]
}

export const articles: Article[] = [
  {
    slug: 'como-comprar-perfil-no-instagram-com-seguranca',
    title: 'Como comprar perfil no Instagram com segurança',
    description:
      'Checklist prático para comprar perfil no Instagram com empresa identificada, métricas reais e transferência assistida.',
    date: '12 de março de 2026',
    read: '8 min',
    image: BLOG_IMAGES.seguranca,
    imageAlt: 'Contrato e smartphone sobre mesa, simbolizando compra segura de perfil no Instagram',
    kicker: 'Guia',
    content: [
      {
        paragraphs: [
          'Comprar perfil no Instagram deixou de ser conversa de grupo e virou operação comercial. Quem busca autoridade pronta, audiência nichada ou um atalho em relação a crescer do zero precisa tratar a compra como due diligence — não como um “combo” vendido no Direct.',
          'Desde 2019 a Muita Mídia organiza esse processo: identificar a conta, mostrar números, formalizar a venda e transferir o acesso com acompanhamento. O texto abaixo é o roteiro que usamos com quem chega pedindo para comprar perfil Instagram pela primeira vez.',
        ],
      },
      {
        heading: 'Comece pela empresa, não pelo @',
        paragraphs: [
          'Antes de olhar seguidores, confira quem está do outro lado. Razão social, CNPJ, endereço e um canal oficial (WhatsApp empresarial, site, Instagram da loja) separam uma venda de perfis Instagram de um golpe. A Muita Mídia LTDA está em Belo Horizonte, na Avenida Afonso Pena, 3355, Sala 1101, CNPJ 51.781.940/0001-04.',
          'Peça comprovantes e desconfie de quem só aceita pagamento para um CPF sem contrato, ou de quem pressiona para “fechar agora porque o perfil vai embora”. Página boa existe todo mês. Urgência artificial é sinal de risco.',
        ],
      },
      {
        heading: 'O que auditar no perfil Instagram à venda',
        paragraphs: [
          'Seguidores reais e orgânicos deixam rastro: comentários repetidos de pessoas diferentes, saves, compartilhamentos e um crescimento que não sobe em linha reta de 10 mil em 48 horas. Peça print de insights, idade da conta, volume de posts e uma amostra da base.',
          'Olhe também o nicho. Comprar página Instagram de humor para vender consultoria jurídica costuma destruir alcance. O algoritmo entrega para quem já interage; mudar o tema de uma hora para outra exige paciência e, em páginas grandes, pode ser um mau negócio.',
        ],
      },
      {
        heading: 'Pagamento e transferência',
        paragraphs: [
          'O fluxo seguro é: acordo por escrito, pagamento identificável, depois troca de e-mail, senha, número e autenticação em dois fatores. Nunca envie o valor integral para um desconhecido que “passa o login depois”. Na Muita Mídia a transferência é assistida — você não recebe um PDF com senha e se vira.',
          'Se quiser aplicar esse checklist na prática, fale com um especialista no WhatsApp e peça opções no seu nicho. Comprar perfil Instagram com método é mais lento na conversa e muito mais rápido no resultado.',
        ],
      },
    ],
  },
  {
    slug: 'quanto-vale-um-perfil-do-instagram',
    title: 'Quanto vale um perfil do Instagram',
    description:
      'Como precificar um perfil Instagram à venda: nicho, engajamento, idade da conta e risco — não só o número de seguidores.',
    date: '4 de fevereiro de 2026',
    read: '7 min',
    image: BLOG_IMAGES.valor,
    imageAlt: 'Calculadora e gráfico de seguidores em um tablet sobre mesa escura',
    kicker: 'Precificação',
    content: [
      {
        paragraphs: [
          'A pergunta “quanto vale um perfil do Instagram” não tem tabela única. Dois perfis de 50 mil seguidores podem ter valores completamente diferentes se um for finanças com 4% de engajamento e o outro for uma página genérica inchada com base fria.',
          'No mercado de venda de perfis Instagram, o preço nasce do cruzamento entre nicho, qualidade da audiência, histórico, username e o trabalho que o comprador ainda terá para monetizar.',
        ],
      },
      {
        heading: 'Seguidores são o cartaz, não o caixa',
        paragraphs: [
          'Faixas ajudam a organizar o catálogo — de 1k a 10k, 10k a 50k, até 300k–900k — mas o valor por mil seguidores cai quando a conta é genérica e sobe quando o nicho converte (finanças, fitness, beleza, pets). Páginas de 1k a 10k servem para teste. Páginas de 100k ou mais cobram o prêmio da distribuição já construída.',
          'Engajamento médio do nicho importa mais que um pico isolado. Um Reels viral não transforma uma base morta em ativo caro.',
        ],
      },
      {
        heading: 'Idade da conta, username e risco',
        paragraphs: [
          'Contas antigas, com posts ao longo dos anos e e-mail original acessível, valem mais porque o Instagram tende a tratar melhor histórico longo. Username curto ou de marca também entra na conta. O inverso — denúncias, quedas bruscas, selos de “seguidores comprados” — derruba o preço ou tira o perfil da prateleira.',
          'Na Muita Mídia, cada perfil Instagram à venda passa por essa leitura antes de chegar no WhatsApp do cliente. Se você está do lado de quem compra, peça o raciocínio do preço, não só o número final.',
        ],
      },
    ],
  },
  {
    slug: 'melhores-nichos-instagram-2026',
    title: 'Melhores nichos para 2026 no Instagram',
    description:
      'Quais nichos de perfil Instagram fazem mais sentido em 2026 para quem quer comprar página pronta e monetizar.',
    date: '18 de janeiro de 2026',
    read: '6 min',
    image: BLOG_IMAGES.nichos,
    imageAlt: 'Moodboard com fotos de moda, comida, viagem, fitness e pets sobre mesa preta',
    kicker: 'Nichos',
    content: [
      {
        paragraphs: [
          'Nicho errado é o jeito mais caro de comprar perfil Instagram. Em 2026, o feed continua premiando interesse específico: quem segue uma página de treino quer treino; quem segue pets quer pets. Audiência “de tudo um pouco” rende vaidade e pouco Pix.',
          'Abaixo, os recortes que mais pedimos no atendimento da Muita Mídia — humor, moda, finanças, fitness, gastronomia, viagens, pets, games, beleza, motivacional, marketing, entretenimento, futebol e cortes — e o que cada um exige do comprador.',
        ],
      },
      {
        heading: 'Alta conversão: finanças, fitness, beleza e pets',
        paragraphs: [
          'Esses quatro nichos sustentam afiliação, infoproduto e marca própria com menos fricção. O público já está em modo de decisão: dieta, skincare, ração, planilha. Comprar página Instagram nesses temas costuma ter payback mais legível, desde que os seguidores sejam reais e o conteúdo anterior não seja clickbait barato.',
        ],
      },
      {
        heading: 'Alcance e comunidade: humor, games, motivacional',
        paragraphs: [
          'Humor e games entregam volume. Motivacional entrega identificação. São ótimos para mídia, lives e produtos de ticket médio, mas castigam quem muda o assunto no dia seguinte. Se for comprar, planeje 30 a 60 dias de conteúdo no mesmo território semântico.',
        ],
      },
      {
        heading: 'Estilo de vida: moda, gastronomia e viagens',
        paragraphs: [
          'Funcionam bem para catálogo, hotel, restaurante e moda. O cuidado é sazonalidade e custo de produção visual. Uma página de viagens de 150 mil com fotos fracas vai exigir investimento criativo depois da transferência.',
          'Não existe “melhor nicho” universal. Existe o nicho que você consegue operar toda semana. Quando isso está claro, a Muita Mídia filtra o catálogo — de 1k a 900k — para não te vender um ativo que você não vai alimentar.',
        ],
      },
    ],
  },
  {
    slug: 'como-transferir-uma-conta-do-instagram',
    title: 'Como transferir uma conta do Instagram',
    description:
      'Passo a passo da transferência assistida: e-mail, senha, celular, autenticação em dois fatores e o que não fazer.',
    date: '9 de dezembro de 2025',
    read: '7 min',
    image: BLOG_IMAGES.transferencia,
    imageAlt: 'Duas pessoas passando um smartphone em uma mesa de reunião durante a transferência da conta',
    kicker: 'Operação',
    content: [
      {
        paragraphs: [
          'Transferir uma conta do Instagram é a etapa em que a maior parte dos prejuízos acontece — não por falha do app, mas por pressa. Login compartilhado no chat, senha reutilizada e autenticação que continua no número do vendedor são os clássicos.',
          'O modelo da Muita Mídia é transferência assistida: as duas partes acompanham a troca até o comprador ser o único com acesso.',
        ],
      },
      {
        heading: 'Ordem que reduz dor de cabeça',
        paragraphs: [
          '1) Confirme que o e-mail e o número cadastrados estão acessíveis. 2) Entre juntos na conta. 3) Troque o e-mail para um endereço seu, novo, só dessa operação. 4) Troque a senha. 5) Atualize o número de celular. 6) Reconfigure a autenticação em dois fatores (app autenticador, não SMS de terceiro). 7) Encerre sessões antigas em Aplicativos e sites.',
          'Só depois disso faça a troca de nome, @, foto e bio. Alterar identidade visual no meio da transferência aumenta chance de bloqueio temporário e confunde o suporte se algo travar.',
        ],
      },
      {
        heading: 'O que o Instagram pode pedir',
        paragraphs: [
          'Contas antigas ou com muitos acessos às vezes disparam verificação extra. Por isso o prazo honesto é “mesmo dia ou até 48 horas úteis”, não “cinco minutos garantidos”. Quem promete milagre nessa etapa costuma pular a autenticação — e o vendedor continua dono na prática.',
          'Se você vai comprar perfil no Instagram agora, exija esse roteiro por escrito. É tão importante quanto o número de seguidores.',
        ],
      },
    ],
  },
  {
    slug: 'seguidores-reais-vs-comprados-a-diferenca',
    title: 'Seguidores reais vs comprados: a diferença',
    description:
      'Como distinguir seguidores reais e orgânicos de base comprada na hora de avaliar um perfil Instagram à venda.',
    date: '21 de novembro de 2025',
    read: '6 min',
    image: BLOG_IMAGES.seguidores,
    imageAlt: 'Comparação visual entre fotos autênticas de estilo de vida e retratos genéricos repetidos',
    kicker: 'Métricas',
    content: [
      {
        paragraphs: [
          'A diferença entre seguidores reais e comprados não é filosófica: é visível nos insights, nos comentários e no caixa. Página com 80 mil fantasmas não vende mentoria, não entrega para o Reels e ainda pode ser limitada pelo Instagram.',
          'Por isso a Muita Mídia só trabalha com perfis que cresceram de forma orgânica. Seguidor de pacote é custo escondido, não bônus.',
        ],
      },
      {
        heading: 'Sinais de base comprada',
        paragraphs: [
          'Picos verticais de milhares de seguidores em poucas horas, contas sem foto, nomes aleatórios, zero saves, comentários de emoji em massa e alcance de Reels ridículo frente ao tamanho da página. Outro indício: o perfil “engaja” em publicação promocional e some no conteúdo comum.',
          'Seguidores reais comentam fora de hora, erram português, marcam amigo, discutem o tema. É bagunçado — e isso é bom.',
        ],
      },
      {
        heading: 'Por que isso muda o valor da compra',
        paragraphs: [
          'Comprar perfil Instagram é comprar distribuição. Se a distribuição é falsa, você pagou por um número na bio. Quando a base é orgânica, cada post tem chance real de circular no nicho, e parcerias deixam de ser constrangedoras.',
          'Na curadoria, olhamos amostra da lista, gráfico de crescimento e qualidade do comentário antes de colocar o perfil no catálogo. Se o número for bonito e a base for oca, a conta simplesmente não vai à venda.',
        ],
      },
    ],
  },
]

export function getArticle(slug: string) {
  return articles.find((item) => item.slug === slug)
}

export function nicheLabel(slug: NicheSlug) {
  return niches.find((item) => item.slug === slug)?.name ?? slug
}
